import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const useCasesSelector = createSelector(stateSelector, (state) => state.useCasesOptions);

const loaderSelector = createSelector(stateSelector, (state) => state.isLoading !== 0);

const onBoardingSelector = createSelector(stateSelector, (state) => {
  return state.onBoarding;
});
const trackingSelector = createSelector(stateSelector, (state) => {
  return state.tracking;
});

const onBoardingConfirmEmailSelector = createSelector(onBoardingSelector, (onBoarding) => onBoarding.confirmEmail);

const onBoardingCurrentEmailSelector = createSelector(onBoardingSelector, (onBoarding) => onBoarding.currentEmail);

const onBoardingBlockReasonSelector = createSelector(onBoardingSelector, (onBoarding) => onBoarding.blockReason);

const userSelector = createSelector(stateSelector, (state) => state.user);
const emailSelector = createSelector(stateSelector, (state) => state.user.email);

const organizationSelector = createSelector(stateSelector, (state) => state.organization);
const isOrgAdminSelector = createSelector(stateSelector, (state) => {
  return state.isOrgAdmin;
});

const isLoggedSelector = createSelector(stateSelector, (state) => {
  return state.isLogged;
});

const isTeamManagementSelector = createSelector(organizationSelector, (state) => state.isTeamManagement);

const isOnBoardingVerifyAPISelector = createSelector(
  onBoardingSelector,
  (onBoarding) => onBoarding.isOnBoardingVerifyAPI,
);
const hasBannerSelector = createSelector(stateSelector, (state) => state.hasBanner);
const allowedApiSelector = createSelector(stateSelector, (state) => state.permittedApps.api);
const allowedSearchSelector = createSelector(stateSelector, (state) => state.permittedApps.search);
const hasApiContextSelector = createSelector(stateSelector, (state) => state.hasApiContext);

export const AppSelectors = {
  useCasesSelector,
  loaderSelector,
  trackingSelector,
  userSelector,
  emailSelector,
  organizationSelector,
  isOrgAdminSelector,
  isLoggedSelector,
  isTeamManagementSelector,

  onBoardingConfirmEmailSelector,
  onBoardingBlockReasonSelector,
  onBoardingCurrentEmailSelector,

  isOnBoardingVerifyAPISelector,
  hasBannerSelector,
  allowedApiSelector,
  allowedSearchSelector,
  hasApiContextSelector,
};
